var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13_496",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13_496)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -52.3076,
    y: -16.9231,
    width: 220,
    height: 135.385,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_13_496",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_13_496",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAABmJLR0QA/wD/AP+gvaeTAAAFHklEQVR4nO2dS4gdRRSGv7nz0AiOYiIhGpVMYiKILyKKEN0oIomvhegqIggBsxEXggsRQcEoCiqCj6UaEVFx1IibID43ZqFgCCImIY7RPNRo1KjJ3HZx5uL1zlSnuvucqrp36oOzGGam+j//dJ9bXXW6BzKZTCaTyWRCMBRbQBcLgSuAdx3fL4DfgJ9mYhfw1Ux8AuwPoLEvGQIuBx5BzGojZrooSmIa2AY8DKy0k9xfLALuBb5mbtNclBndHW3gQ+AWoGWSQeIsBh4HfqfcKBe+RnfHF8CN+qmkyRhwN/Arfua4qGN0J7YAZ+mmlRZrgG+oZoqLJkYXwCHgVs3kUmAE2AQco7ohLpoa3anfm4BhrURjsgjYSn0zXGgY3YnXgFGddOOwHNhJMxNcaBpdAG8hnx99xwXAXpob4ELb6AJ4ibRu2o7LCuAHdJJ3YWF0AdzfOPtAnAnsRi9xF1ZGt4FrG3pgziiyzqCZuAsrowvge2StJVmeQz9pF5ZGF8DmRk4Ycj02CbuwNroArmzghwmnoTPDSM3oz0lsFvI0dsm6CGF0AdxQ2xVlzgP+YXCN/riuMdpsxjZRF6GMLoDLanqjxgRwlME3+pl69ujxJPZJughp9EEiroOMAQeOI3BQjC6A6+qY5KLKntpaZAl0vqB6W17F6GSmPYFQNdp3cj4EfIcsIFnj0lRWViwokCv4Z43BfM/ocwljckoMARdpDeZr9GqtA/YZl2gN5Gv0xVoHLOEgshro4nmkFSwkwbueXsFuGvUjcBd+m6VjwMaZ3wkxxXP1AZrxgZLw3tiCrARWZRx400hTd3xZQ1sjdigJ745nabYk2ULKiaXR0wRuKTuknMAb6DQgDmN/Zh8GLlTQ6sXfisL3Uq9cuDgVmFLUN1fsRpo0zflFUfR6A313KOpzxafACQba/4dWz8YUNq1Yo8AeJY1l8WJdgb518kjdA/TwKrKerc1RpO5bsx64z/IA29A5I9YaarTale+NaeBmqyReVhJ5jpVAYJmSRp/4E7i0ijjf0rGjyqAlHFAaZy72GY7dywJgkgoLbb5Gb68lZzaWDeChm8vPAF4HTtQcdAKdS85ykWaVksaq8ZiPON8zeifyuFpTJhTGcLHccOwybvf5oSq3we/UFNLNOoUxYoxdhnoL2VU0v8z2YFNLR5CttmRLRxWG0blDvFNbGLBBQVfVOAw8ivyR1XlAQeAUcLKipnHsOlt74wiyWngbcJJiDrM4HZmsNxX8HjolpAW8raCnLI4hTzVsAE5R0OzNC0oJPEWzNekWtu3DnYjWNLQC+MtDoE9MUq+MjCOzoBDlIioPoZfIfuShfJ8PlRYybw1Vk9WMrjsHXIDcli/TEoJ8SE4iG7a7Zr4GWIrc6KxD9u+WKh7Th+iPWoRalowdSfAE8Y2YF0aPYNfzkUqooFF/FiM7MKFrZyhUarRGb8U+4BpkJpAJwErkmerYl3qSpUObVYSd485bo0Gat7VbyGJFW9kbda7mvzcz9nOobSZbvelwK9JT3e98FFuAD2ej2xwZI6I/quzL+8Q3q26ob1FZspH4hlWNP+ijF1p1WE1843xjO/AgsMTECWOWEN/AsvgW2elZY2VAKIaJb6brzD3fMO8oxDa2QNokBtLcbmIa3EYMNm0NSIWYRt8TIL9kiGXyZyGSS4lYRt8UIjlfQuzwFgGOMRcLUXrXhgaDbHQr4rFnMcj/pyQZk2GwjU6KbHQgstGZTCaTyWQyA8W/otCLyKSQhkcAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.d11743bd568330cc9a9261de2b2b589e.svg";
export { ForwardRef as ReactComponent };